// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-PatientPage-Messages-__conversation-list-item__wrapper--3gfKi","selected":"src-components-PatientPage-Messages-__conversation-list-item__selected--2bh6_","header":"src-components-PatientPage-Messages-__conversation-list-item__header--1mlxl","subject":"src-components-PatientPage-Messages-__conversation-list-item__subject--hvgg2","textSubject":"src-components-PatientPage-Messages-__conversation-list-item__textSubject--e8CeE"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PatientPage/Messages/conversation-list-item.css
// module id = 1983
// module chunks = 0